import { useCallback, useState } from 'react'

import { useAppContext } from '../../../app-context'
import { showErrorAlert } from '../../alert'
import { triggerBrowserDownload } from '../../../util/file'
import { IDocument } from '../../../interfaces'
import { FetchDocumentContent } from './document-upload-context-types'

const useDownloadDocument = (fetchDocumentContent: FetchDocumentContent) => {
  const { dispatch } = useAppContext()

  const [downloadingDocumentIds, setDownloadingDocumentIds] = useState<number[]>([])

  const downloadDocument = useCallback(
    async (document: IDocument) => {
      if (!document.contentUrl) {
        return
      }

      setDownloadingDocumentIds(downloadingDocumentIds => [...downloadingDocumentIds, document.id])

      try {
        const blob = await fetchDocumentContent(document, { download: true })
        triggerBrowserDownload(blob, String(document.name))
      } catch (err) {
        console.warn('Something went wrong during document download', err)
        dispatch(showErrorAlert('Something went wrong during document download'))
      }

      setDownloadingDocumentIds(downloadingDocumentIds =>
        downloadingDocumentIds.filter(documentId => documentId !== document.id),
      )
    },
    [fetchDocumentContent, dispatch],
  )

  return { downloadDocument, downloadingDocumentIds }
}

export default useDownloadDocument
